import { DataSource, Layout, Textbox, } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningProfileQuickInfo extends Layout {
    sourceBrokeragePlanningProfile: DataSource;
    textboxTitle: Textbox;
}
